module.exports = "https://static.zego.com/_next/static/images/linkedin-5fa550755774dca0125b6f3349982897.svg";